export default "__VITE_ASSET__BqapWCo3__"